var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4169 20.1781C16.7036 20.1781 20.1788 16.703 20.1788 12.4162C20.1788 8.12943 16.7036 4.6543 12.4169 4.6543C8.13003 4.6543 4.65491 8.12943 4.65491 12.4162C4.65491 16.703 8.13003 20.1781 12.4169 20.1781Z",
    stroke: "#207C97",
    strokeWidth: 1.54762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72737 16.8211C3.35833 18.9163 2.7988 20.5234 3.38214 21.1068C4.48928 22.2139 9.35833 19.1544 14.2512 14.2615C19.156 9.35674 22.2155 4.4996 21.1084 3.38055C20.5251 2.79722 18.9179 3.35674 16.8227 4.72579",
    stroke: "#207C97",
    strokeWidth: 1.54762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.79ffdb9f8baca88f0def9e4d5d825313.svg";
export { ForwardRef as ReactComponent };